import { AbstractControl } from '@angular/forms';
import { isValidPassword } from '@array-app/shared/utils';

export function passwordValidator(control: AbstractControl) {
	if (!isValidPassword(control.value)) {
		return { invalidPassword: true };
	}
	return null;
}
